<template>
    <div
        class="bg-cool-gray-50 p-4 rounded-xl"
    >
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'v-card',
}

</script>
